import Divider from 'components/styles/general-elements/Divider';
import React from 'react';
import { Article } from 'src/types/sanity/schema';
import { PortableText } from 'utils/sanity/sanity';
import { ArticleContentStyles } from './JournalStyles';

interface ArticleContentProps {
    content: Article['body'];
}

const ArticleContent: React.FC<ArticleContentProps> = ({ content }) => {
    if (!content) return <ArticleContentStyles />;

    // const parsedContent = parseWPHtml(content);
    // const firstLetter = parsedContent[0];

    return (
        <ArticleContentStyles className="ArticleContent-container breakout-grid">
            <PortableText className="PortableText-container" blocks={content} />
            {/* <Divider size={{ top: 'none', bottom: 's' }} color="white" /> */}
        </ArticleContentStyles>
    );
};

export default ArticleContent;
